module.exports = __webpack_public_path__ + "static/dinosaur_left-547d6d1b05922efa5cf5a8ef2877be6c.png";